// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"5c994696","354":"5c5d8f0e","538":"242a1da1","787":"872e2624","850":"4cccbab3","913":"fe20fff6"}[chunkId] + ".chunk.js";
};